import config from '../../config';

// Segment is intentionally NOT auto-loaded in the SSR head (ENG-2641): calling analytics.load()
// writes the persistent ajs_anonymous_id cookie and lets anonymous browse traffic count toward
// MTU. Callers invoke this once the visitor is authenticated (or on a wanted anonymous
// conversion such as the NCSA form). The latch keeps logout/login churn from re-injecting the
// analytics.js script.
let segmentLoadRequested = false;

export const ensureSegmentLoaded = () => {
    if (segmentLoadRequested || !config.segmentKey) {
        return;
    }
    if (typeof window !== 'undefined' && window.analytics) {
        window.analytics.load(config.segmentKey);
        segmentLoadRequested = true;
    }
};
